"use client";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { getMarketingMarkdownComponents } from "@/components/markdown/marketing-markdown";

interface LegalDocumentContentProps {
  content: string;
}

export default function LegalDocumentContent({
  content,
}: LegalDocumentContentProps) {
  // Use shared components with heading IDs to support sidebar linking
  const components = getMarketingMarkdownComponents({ withHeadingIds: true });

  return (
    <div className="flex-1 lg:max-w-4xl">
      <div className="prose prose-lg max-w-none">
        <ReactMarkdown components={components} remarkPlugins={[remarkGfm]}>
          {content}
        </ReactMarkdown>
      </div>
    </div>
  );
}
